import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { get } from 'ctm-util-functions';
import { Text } from '../../text/text';
import { ProductAdditionalExcessListItem } from '../product_additional_excess_list_item/product_additional_excess_list_item';

/**
 * Render ProductAdditionalExcessList
 * @param {String} label - The heading label
 * @param {String} size - The heading font size
 * @param {String} color - The heading font color
 * @param {String} tagName - The heading tag name
 * @param {String} stateKey - The stateKey for the form
 * @param {Object} stateProps - The state from the application
 * @return {Node} ProductAdditionalExcessList
 */
const ProductAdditionalExcessList = ({ label, size, color, tagName, stateKey, stateProps }) => {
    const additionalExcess = get(stateProps, stateKey);
    if (!additionalExcess) return null;
    const additionalExcessList = renderProductAdditionalExcessList(additionalExcess);
    const heading = <Text label={label} size={size} color={color} tagName={tagName} />;
    return (
        <>
            {heading}
            {additionalExcessList}
        </>
    );
};

/**
 * Render ProductAdditionalExcessList Items
 * @param {Immutable.List} additionalExcess AdditionalExcess
 * @returns {Array} Flexbox with Additional Excess Title and List
 */
const renderProductAdditionalExcessList = (additionalExcess) => {
    return additionalExcess.size > 0 ? additionalExcess.map((excess) => {
        const label = excess.getIn(['description']);
        let amount = excess.getIn(['amount']);
        // Add $ prefix if the amount doesn't contain one (HNC has a $ prefix while Car doesn't)
        amount = !amount.includes('$') ? `$${amount}` : amount;
        return <ProductAdditionalExcessListItem key={label} label={label} amount={amount} />;
    }).toArray() : (<p>Refer to PDS</p>);
};

ProductAdditionalExcessList.propTypes = {
    label: PropTypes.string.isRequired,
    size: PropTypes.string.isRequired,
    color: PropTypes.string.isRequired,
    tagName: PropTypes.string.isRequired,
    stateKey: PropTypes.string.isRequired,
    stateProps: PropTypes.object.isRequired
};

export { ProductAdditionalExcessList, renderProductAdditionalExcessList };
